/* eslint-disable no-unused-vars */
import { useNavigate } from 'react-router-dom';

import config from '@/config';
import useCache from '@/hooks/useCache';
import useNavigateToArtwork from '@/hooks/useNavigateToArtwork';
import Loader from '@/shared-components/loader/Loader';
import Text from '@/shared-components/text/components/Text';

import ArtistArtworksHeader from '../../components/ArtistArtworksHeader';

import VirtualList from './components/VirtualList';

import './index.css';

export default function Artworks({ artist, profileData, internal, queryEndpoint = null, cacheKey = null }) {

  const endpoint = queryEndpoint ? queryEndpoint :
    `/gallery/${profileData._id}/artist/${artist._id}/artworks?artist_type=${
      artist.gallery_artist ? "artist" : "gallery_artist"}`;

  const cacheKeyToUse = cacheKey ? cacheKey : `artworks_of_${artist._id}_in_${profileData._id}`;

  const invalidateWhen =  profileData ? 
    internal ? ["EDIT_ARTWORK", "DELETE_ARTWORK", "NEW_ARTIST", `${profileData._id}_REFRESH`]
      : [`${profileData._id}_REFRESH`] : [];

  const { loading, fetchData, loadMoreData } = useCache(
    cacheKeyToUse,
    `${config.apis.api.url}${endpoint}`,
    {
      injectToken: true,
      includeSearchQueries: { 
        // it is included in the url
      },
      invalidateWhen,
    }
  );

  const navigateToArtwork = useNavigateToArtwork(
    cacheKeyToUse,
    fetchData,
    endpoint,
  );

  const navigate = useNavigate();

  function navigateToProfileIfPossible() {
    if (artist.gallery_artist) {
      navigate(`/user/${artist.user_username}`, { state: { from: true } });
    }
  }

  return (
    <>
      <div
        className={`artist-artworks-content__header ${
          artist.gallery_artist ? "click" : ""
        }`}
        onClick={navigateToProfileIfPossible}
      >
        <ArtistArtworksHeader artistData={artist} preview />
      </div>

      <Text className="artist-artworks-content__artwork-count" paragraph extraSmall>
        {artist.artwork_count || fetchData?.data.length} artworks
      </Text>

      {loading ? (
        <Loader className="artist-artworks-content__content-spinner" thin />
      ) : (
        <VirtualList
          items={fetchData}
          onLoadMore={loadMoreData}
          navigateToArtwork={navigateToArtwork}
        />
      )}
    </>
  );
}
